import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import * as xml2js from "xml2js";
import { NewsRss } from './news-rss';
@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css']
})
export class NewsComponent implements OnInit {
  RssData: NewsRss;
  imageObject: Array<object> = [];
  constructor(private http: HttpClient) { }

  GetRssFeedData() {
    const requestOptions: Object = {
      observe: "body",
      responseType: "text"
    };
    this.http
      .get<any>("https://gadgets.ndtv.com/rss/feeds", requestOptions)
      .subscribe(data => {
        let parseString = xml2js.parseString;
        parseString(data, (err, result: NewsRss) => {
          this.RssData = result;
          console.log(result);
          if (this.RssData.rss.channel[0].image.length > 0) {
            for (let i = 0; i < this.RssData.rss.channel[0].image.length; i++) {
                this.imageObject.push({image: this.RssData.rss.channel[0].image[i].url[0],
                    thumbImage: this.RssData.rss.channel[0].image[i].url[0] })
            }
          }
        });
      });
  }
  ngOnInit(): void {
    this.GetRssFeedData() ;
  }

}
